import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { PageHeader, notification } from "antd";
import { useTranslation } from "react-i18next";
import { useMutation } from "@apollo/client";

import {
  CREATE_FINANCE_ACCOUNT_MUTATION,
  FINANCE_ACCOUNTS_QUERY,
} from "./accountsQueries";

import AccountForm from "./components/AccountForm";

const StyledPageHeader = styled(PageHeader)`
  background: none;
  padding: 20px 40px 0px 40px;
`;

const NewAccount = ({ history }) => {
  const { t } = useTranslation();
  const [createAccount] = useMutation(CREATE_FINANCE_ACCOUNT_MUTATION, {
    refetchQueries: [{
      query: FINANCE_ACCOUNTS_QUERY,
    }],
  });

  const handleSubmit = (values) =>
    createAccount({
      variables: {
        data: {
          ...values,
          current_balance: values.start_balance,
        },
      },
    })
      .then(() => history.goBack())
      .catch(notification.error);

  return (
    <div>
      <StyledPageHeader
        onBack={() => history.goBack("/finance/accounts")}
        title={t("finance.Account.AddPage.Title")}
      />
      <AccountForm onSubmit={handleSubmit} t={t} />
    </div>
  );
};

NewAccount.propTypes = {
  history: PropTypes.object.isRequired,
};

export default NewAccount;
